import * as Sentry from "@sentry/gatsby";

export const sentryService = {
  setUser: (user) => {
    Sentry.setUser(user);
  },
  removeUser: () => {
    Sentry.setUser(null);
  },
  setTag: (key, value) => {
    Sentry.setTag(key, value);
  },
  removeTag: (key) => {
    Sentry.setTag(key, undefined);
  },
  captureMessage: (message) => {
    Sentry.captureMessage(message);
  },
};
